module.exports = __webpack_public_path__ + "assets/img/yi_index_dz.668a8788.png";